/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

// Vite does not allow importing a non-transpiled package from `node_modules/`.
// Hence, the `@ckeditor/ckeditor5-metadata` package exposes its entry point as a JavaScript file
// and all its files must export the JavaScript code only.
//
// See: https://github.com/vitejs/vite/issues/5370.
//
// Make sure to synchronize the typings file (`./index.d.ts`) whenever you modify this file.

import { default as _plugins } from './plugins/output/plugins.json' with { type: 'json' };
import { default as _config } from './cdns/config.json' with { type: 'json' };
import { default as pkgJson } from '../package.json' with { type: 'json' };

const ckboxService = _config.services.find( service => service.loaderPath === 'CKBox' );

export const plugins = _plugins;
export const CDNs = _config;
export const CKEDITOR5_VERSION = pkgJson.dependencies.ckeditor5;
export const CKBOX_VERSION = ckboxService.version;
export const CKBOX_URL = ckboxService.resourceUrl;
